import { Checkbox, FormControl, InputLabel, ListItemText } from "@mui/material";

import { MyMenuItem, MySelect } from "~/mui/MySelect";

import "./style.less";
import { useEffect, useState } from "react";
import { apiGetQueryTypesServices } from "~/providers/api";
import { useTrans } from "~/hooks/useTrans";

interface IConsumedResourcesSelect {
	value: string | null;
	onChange: (value: string | null) => void;
}

export default function ConsumedResourcesSelect({
	value,
	onChange = () => {},
}: IConsumedResourcesSelect) {
	const { trans } = useTrans();
	const [allConsumableResources, setAllConsumableResources] = useState<Array<string>>([]);

	useEffect(() => {
		apiGetQueryTypesServices().then(({ data }) => {
			setAllConsumableResources(data);
		});
	}, []);

	function getValue() {
		if (typeof value === "string") {
			return value.split(",");
		}

		return [];
	}

	function isChecked(consumedResource: string) {
		const values = value || "";

		return values.indexOf(consumedResource) !== -1;
	}

	function getTitle(selected: Array<string>) {
		if (selected.length > 0) {
			return `${trans("allProjectsPage.filter.consumedResources.selected")}: ${selected.length}`;
		}

		return trans("allProjectsPage.filter.consumedResources.empty");
	}

	function updateFilter(newValue: Array<string>) {
		let updatedValue = null;

		if (newValue.length !== 0) {
			updatedValue = newValue.join(",");
		}

		onChange(updatedValue);
	}

	return <FormControl size="small" sx={{ minWidth: "175px" }}>
		<InputLabel shrink={true}>
			{trans("allProjectsPage.filter.consumedResources")}
		</InputLabel>
		<MySelect
			value={getValue()}
			onChange={event => updateFilter(event.target.value as Array<string>)}
			label={trans("allProjectsPage.filter.consumedResources")}
			renderValue={(selected: Array<string>) => getTitle(selected)}
			multiple={true}
			className="consumedResourcesSelect"
		>
			{allConsumableResources.map((resource: string) => (
				<MyMenuItem key={resource} value={resource}>
					<Checkbox checked={isChecked(resource)} />
					<ListItemText primary={resource} />
				</MyMenuItem>
			))}
		</MySelect>
	</FormControl>;
}
